export default [
    {
        path: 'organizations',
        name: 'organizations-master-data',
        meta: {
            modules: ['organization'],
            authentication_required: true,
            authorization_required: ['modules.organization'],
            translate: (t) => {
                return t('menu_points.organization').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        children: [
            {
                path: 'locations',
                name: 'organizations-locations',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.locations.view'],
                    translate: (t) => {
                        return t('menu_points.locations').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-locations-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-locations-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.locations.view'],
                            translate: (t) => {
                                return t('menu_points.locations').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/locations/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-location-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.location.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::locations.location', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/locations/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-location-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.location.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::locations.location', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/locations/item.vue')
                    }
                ]
            },
            {
                path: 'organization-types',
                name: 'organizations-organization-types',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.organization_types.view'],
                    translate: (t) => {
                        return t('menu_points.organization_types').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-organization-types-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-organization-types-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.organization_types.view'],
                            translate: (t) => {
                                return t('menu_points.organization_types').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/organization-types/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-organization-type-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.organization_type.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::organization_types.organization_type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/organization-types/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-organization-type-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.organization_type.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::organization_types.organization_type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/organization-types/item.vue')
                    }
                ]
            },
            {
                path: 'organization-statuses',
                name: 'organizations-organization-statuses',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.organization_statuses.view'],
                    translate: (t) => {
                        return t('menu_points.organization_statuses').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-organization-statuses-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-organization-statuses-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.organization_statuses.view'],
                            translate: (t) => {
                                return t('menu_points.organization_statuses').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/organization-statuses/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-organization-status-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.organization_status.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::organization_statuses.organization_status', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/organization-statuses/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-organization-status-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.organization_status.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::organization_statuses.organization_status', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/organization-statuses/item.vue')
                    }
                ]
            },
            {
                path: 'sizes',
                name: 'organizations-sizes',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.sizes.view'],
                    translate: (t) => {
                        return t('menu_points.organization_sizes').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-sizes-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-sizes-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.sizes.view'],
                            translate: (t) => {
                                return t('menu_points.organization_sizes').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/sizes/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-size-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.size.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::sizes.size', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/sizes/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-size-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.size.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::sizes.size', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/sizes/item.vue')
                    }
                ]
            },
            {
                path: 'industries',
                name: 'organizations-industries',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.industries.view'],
                    translate: (t) => {
                        return t('menu_points.organization_industries').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-industries-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-industries-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.industries.view'],
                            translate: (t) => {
                                return t('menu_points.organization_industries').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/industries/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-industry-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.industry.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::industries.industry', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/industries/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-industry-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.industry.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::industries.industry', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/industries/item.vue')
                    }
                ]
            },
            {
                path: 'ownership-types',
                name: 'organizations-ownership-types',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.ownership_types.view'],
                    translate: (t) => {
                        return t('menu_points.ownership_types').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-ownership-types-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-ownership-types-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.ownership_types.view'],
                            translate: (t) => {
                                return t('menu_points.ownership_types').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/ownership-types/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-ownership-type-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.ownership_type.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::ownership_types.ownership_type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/ownership-types/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-ownership-type-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.ownership_type.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::ownership_types.ownership_type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/ownership-types/item.vue')
                    }
                ]
            },
            {
                path: 'governance-models',
                name: 'organizations-governance-models',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.governance_models.view'],
                    translate: (t) => {
                        return t('menu_points.governance_models').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-governance-models-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-governance-models-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.governance_models.view'],
                            translate: (t) => {
                                return t('menu_points.governance_models').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/governance-models/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-governance-model-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.governance_model.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::governance_models.governance_model', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/governance-models/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-governance-model-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.governance_model.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::governance_models.governance_model', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/governance-models/item.vue')
                    }
                ]
            },
            {
                path: 'positions',
                name: 'organizations-positions',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.positions.view'],
                    translate: (t) => {
                        return t('menu_points.positions').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-positions-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-positions-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.positions.view'],
                            translate: (t) => {
                                return t('menu_points.positions').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/positions/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-position-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.position.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::positions.position', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/positions/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-position-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.position.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::positions.position', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/positions/item.vue')
                    }
                ]
            },
            {
                path: 'knowledge-levels',
                name: 'organizations-knowledge-levels',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.knowledge_levels.view'],
                    translate: (t) => {
                        return t('menu_points.knowledge_levels').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-knowledge-levels-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-knowledge-levels-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.knowledge_levels.view'],
                            translate: (t) => {
                                return t('menu_points.knowledge_levels').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/knowledge-levels/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-knowledge-level-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.knowledge_level.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::knowledge_levels.knowledge_level', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/knowledge-levels/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-knowledge-level-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.knowledge_level.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::knowledge_levels.knowledge_level', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/knowledge-levels/item.vue')
                    }
                ]
            },
            {
                path: 'skill-types',
                name: 'organizations-skill-types',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.skill_types.view'],
                    translate: (t) => {
                        return t('menu_points.skill_types').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-skill-types-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-skill-types-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.skill_types.view'],
                            translate: (t) => {
                                return t('menu_points.skill_types').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/skill-types/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-skill-type-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.skill_type.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::skill_types.skill_type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/skill-types/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-skill-type-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.skill_type.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::skill_types.skill_type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/skill-types/item.vue')
                    }
                ]
            },
            {
                path: 'skills',
                name: 'organizations-skills',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.skills.view'],
                    translate: (t) => {
                        return t('menu_points.skills').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-skills-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-skills-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.skills.view'],
                            translate: (t) => {
                                return t('menu_points.skills').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/skills/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-skill-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.skill.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::skills.skill', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/skills/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-skill-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.skill.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::skills.skill', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/skills/item.vue')
                    }
                ]
            },
            {
                path: 'skill-levels',
                name: 'organizations-skill-levels',
                meta: {
                    modules: ['organization'],
                    authentication_required: true,
                    authorization_required: ['roles.skill_levels.view'],
                    translate: (t) => {
                        return t('menu_points.skill_levels').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: {name: 'organizations-skill-levels-list'},
                children: [
                    {
                        path: '',
                        name: 'organizations-skill-levels-list',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.skill_levels.view'],
                            translate: (t) => {
                                return t('menu_points.skill_levels').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/organization/skill-levels/list.vue'),
                    },
                    {
                        path: 'create',
                        name: 'organizations-skill-level-create',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.skill_level.create'],
                            translate: (t, tc) => t('base.create_new_item', {item: tc('organizations::skill_levels.skill_level', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/skill-levels/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'organizations-skill-level-edit',
                        meta: {
                            modules: ['organization'],
                            authentication_required: true,
                            authorization_required: ['roles.skill_level.update'],
                            translate: (t, tc) => t('base.edit_item', {item: tc('organizations::skill_levels.skill_level', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/organization/skill-levels/item.vue')
                    }
                ]
            }
        ]
    }
];
